import React from "react";
import { motion } from 'framer-motion';
import { Button } from "@/components/ui/button";
import { Loader2, Save, X, WandSparkles } from "lucide-react";
import { cn } from "@/lib/utils";

interface NewWorkbookFooterProps {
  onCancel: () => void;
  onSubmit: () => void;
  isSubmitting: boolean;
  isValid: boolean;
  submitText?: string;
}

const NewWorkbookFooter: React.FC<NewWorkbookFooterProps> = ({
  onCancel,
  onSubmit,
  isSubmitting,
  isValid,
  submitText = "Create Project",
}) => {
  return (
    <div className="flex items-center justify-end gap-3">
      <Button 
        variant="outline" 
        size="sm" 
        onClick={onCancel} 
        disabled={isSubmitting}
        className="border-border/50 hover:border-border"
      >
        <X size={16} className="mr-2" />
        Cancel
      </Button>
      
      <Button
        variant="default"
        size="sm"
        onClick={onSubmit}
        disabled={!isValid || isSubmitting}
        className={cn(
          "bg-purple-600 hover:bg-purple-700 text-white border-purple-600",
          "disabled:bg-muted disabled:text-muted-foreground disabled:border-muted",
          "transition-all duration-200"
        )}
      >
        {isSubmitting ? (
          <>
            <motion.div
              animate={{ rotate: 360 }}
              transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
              className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full mr-2"
            />
            Creating...
          </>
        ) : (
          <>
            <WandSparkles size={16} className="mr-2" />
            {submitText}
          </>
        )}
      </Button>
    </div>
  );
};

export default NewWorkbookFooter;
